// import React, { useState } from 'react';
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell
// } from 'recharts';

// // Sample data for the component
// const revenueData = {
//   total: {
//     revenue: 1250000,
//     growth: 15.5
//   },
//   lineChartData: [
//     { name: 'Jan', revenue: 400000, growth: 10 },
//     { name: 'Feb', revenue: 450000, growth: 12.5 },
//     { name: 'Mar', revenue: 500000, growth: 15 },
//     { name: 'Apr', revenue: 550000, growth: 17.5 },
//     { name: 'May', revenue: 600000, growth: 20 },
//     { name: 'Jun', revenue: 650000, growth: 22.5 }
//   ],
//   barChartData: [
//     { name: 'MBA', revenue: 300000 },
//     { name: 'Masters', revenue: 250000 },
//     { name: 'PHD', revenue: 200000 },
//     { name: 'Bachelors', revenue: 100000 }
//   ],
//   pieChartData: [
//     { name: 'USA', value: 400000 },
//     { name: 'UK', value: 300000 },
//     { name: 'Germany', value: 200000 },
//     { name: 'Dubai', value: 100000 }
//   ]
// };

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// const NewRevenue = () => {
//   const [selectedYear, setSelectedYear] = useState('2023');
//   const [selectedMonth, setSelectedMonth] = useState('June');

//   const years = ['2023', '2022', '2021'];
//   const months = [
//     'January', 'February', 'March', 'April',
//     'May', 'June', 'July', 'August',
//     'September', 'October', 'November', 'December'
//   ];
//   const data = [
//     {
//       name: 'Jan',
//       service1: 10,
//       service2: 8,
//       service3: 12
//     },
//     {
//       name: 'Feb',
//       service1: 12,
//       service2: 11,
//       service3: 14
//     },
//     {
//       name: 'Mar',
//       service1: 15,
//       service2: 13,
//       service3: 16
//     },
//     {
//       name: 'Apr',
//       service1: 18,
//       service2: 16,
//       service3: 19
//     },
//     {
//       name: 'May',
//       service1: 20,
//       service2: 19,
//       service3: 21
//     },
//     {
//       name: 'Jun',
//       service1: 23,
//       service2: 21,
//       service3: 24
//     }
//   ];
//   return (
//     <div className="p-6 bg-gray-100 min-h-screen">
//       {/* Top Cards */}
//       <div className="grid grid-cols-2 gap-4 mb-6">
//         <div className="bg-white rounded-lg shadow-md p-4">
//           <div className="text-sm font-medium text-gray-500 mb-2">Total Revenue</div>
//           <div className="text-2xl font-bold text-blue-600">
//             ${revenueData.total.revenue.toLocaleString()}
//           </div>
//         </div>
//         <div className="bg-white rounded-lg shadow-md p-4">
//           <div className="text-sm font-medium text-gray-500 mb-2">Revenue Growth</div>
//           <div className="text-2xl font-bold text-green-600">
//             {revenueData.total.growth}%
//           </div>
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="grid grid-cols-2 gap-6">
//         {/* Left Side - Charts */}
//         <div className="space-y-4">
//           {/* Revenue Line Chart */}
//           <div className="bg-white rounded-lg shadow-md p-4">
//             <h3 className="text-lg font-semibold mb-4">Monthly Revenue</h3>
//             <ResponsiveContainer width="100%" height={250}>
//               <LineChart data={revenueData.lineChartData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line type="monotone" dataKey="revenue" stroke="#8884d8" activeDot={{r: 8}} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>

//           {/* Growth Line Chart */}
//           <div className="bg-white rounded-lg shadow-md p-4">
//       <h3 className="text-lg font-semibold mb-4">Service Revenue</h3>
//       <ResponsiveContainer width="100%" height={300}>
//         <LineChart data={data}>
//           <CartesianGrid strokeDasharray="3 3" />
//           <XAxis dataKey="name" />
//           <YAxis />
//           <Tooltip />
//           <Legend />
//           <Line
//             type="monotone"
//             dataKey="service1"
//             stroke="#82ca9d"
//             activeDot={{ r: 8 }}
//             name="Service 1"
//           />
//           <Line
//             type="monotone"
//             dataKey="service2"
//             stroke="#8884d8"
//             activeDot={{ r: 8 }}
//             name="Service 2"
//           />
//           <Line
//             type="monotone"
//             dataKey="service3"
//             stroke="#ffc658"
//             activeDot={{ r: 8 }}
//             name="service3"
//           />
//         </LineChart>
//       </ResponsiveContainer>
//     </div>

//           {/* Product Revenue Bar Chart */}
//           <div className="bg-white rounded-lg shadow-md p-4">
//             <h3 className="text-lg font-semibold mb-4">Level Revenue</h3>
//             <ResponsiveContainer width="100%" height={250}>
//               <BarChart data={revenueData.barChartData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="revenue" fill="#8884d8" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Right Side - Pie Chart and Filters */}
//         <div className="space-y-4">
//           {/* Revenue by Segment Pie Chart */}
//           <div className="bg-white rounded-lg shadow-md p-4">
//             <h3 className="text-lg font-semibold mb-4">Revenue by Segment</h3>
//             <ResponsiveContainer width="100%" height={300}>
//               <PieChart>
//                 <Pie
//                   data={revenueData.pieChartData}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {revenueData.pieChartData.map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//                 <Legend />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>

//           {/* Filters
//           <div className="bg-white rounded-lg shadow-md p-4">
//             <h3 className="text-lg font-semibold mb-4">Filters</h3>
//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Select Year</label>
//                 <select
//                   className="w-full p-2 border rounded-md"
//                   value={selectedYear}
//                   onChange={(e) => setSelectedYear(e.target.value)}
//                 >
//                   {years.map((year) => (
//                     <option key={year} value={year}>
//                       {year}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">Select Month</label>
//                 <select
//                   className="w-full p-2 border rounded-md"
//                   value={selectedMonth}
//                   onChange={(e) => setSelectedMonth(e.target.value)}
//                 >
//                   {months.map((month) => (
//                     <option key={month} value={month}>
//                       {month}
//                     </option>
//                   ))}
//                 </select>
//               </div>
//             </div>
//           </div> */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewRevenue;

// import React, { useState, useEffect } from 'react';
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer
// } from 'recharts';
// import axios from 'axios';

// const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [revenueData, setRevenueData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchRevenueData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) {
//           params.append('year', selectedYear);
//         }

//         if (selectedMonth && selectedMonth !== 'All') {
//           const monthAbbrev = selectedMonth.slice(0, 3);
//           params.append('month', monthAbbrev);
//         }

//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         'Fetching revenue with params:', {
//           year: selectedYear,
//           month: selectedMonth,
//           admin: selectedAdmin,
//           queryString: params.toString()
//         });

//         const response = await axios.get(
//           `http://127.0.0.1:8000/dashboard/api/revenue_summary/?${params.toString()}`
//         );

//         'Revenue API Response:', response.data);
//         setRevenueData(response.data);
//         setError(null);
//       } catch (err) {
//         console.error('Revenue API Error:', err);
//         setError(err.message || 'Failed to fetch revenue data');
//         setRevenueData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRevenueData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   // Transform data based on which response we got
//   const transformData = () => {
//     if (!revenueData) return { chartData: [], chartType: 'bar' };

//     if (revenueData.monthly_revenue) {
//       // Case: Year provided, show monthly data
//       const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//       return {
//         chartData: Object.entries(revenueData.monthly_revenue).map(([month, revenue]) => ({
//           name: monthNames[parseInt(month) - 1],
//           revenue: revenue
//         })),
//         chartType: 'bar'
//       };
//     }

//     if (revenueData.yearly_revenue) {
//       // Case: No specific year or month provided
//       return {
//         chartData: Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//           name: year,
//           revenue: revenue
//         })),
//         chartType: 'bar'
//       };
//     }

//     return { chartData: [], chartType: 'bar' };
//   };

//   const { chartData, chartType } = transformData();

//   return (
//     <div className="p-6 bg-white">
//       {/* Top Cards */}
//       <div className="grid grid-cols-2 gap-4 mb-6">
//         <div className="bg-white rounded-lg shadow-md p-4">
//           <div className="text-sm font-medium text-gray-500 mb-2">Total Revenue</div>
//           <div className="text-2xl font-bold text-blue-600">
//             ${revenueData?.total_revenue?.toLocaleString() || '0'}
//           </div>
//         </div>
//         <div className="bg-white rounded-lg shadow-md p-4">
//           <div className="text-sm font-medium text-gray-500 mb-2">Revenue Growth</div>
//           <div className="text-2xl font-bold text-green-600">
//             {revenueData?.revenue_growth?.toFixed(2) || '0'}%
//           </div>
//         </div>
//       </div>

//       {/* Revenue Chart */}
//       <div className="bg-white rounded-lg shadow-md p-4">
//         <h3 className="text-lg font-semibold mb-4">
//           {selectedYear ? 'Monthly Revenue' : 'Yearly Revenue'}
//         </h3>
//         <ResponsiveContainer width="100%" height={400}>
//           <BarChart data={chartData}>
//             <CartesianGrid strokeDasharray="3 3" />
//             <XAxis dataKey="name" />
//             <YAxis />
//             <Tooltip
//               formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']}
//             />
//             <Legend />
//             <Bar
//               dataKey="revenue"
//               name="Revenue"
//               fill="#0088FE"
//               radius={[4, 4, 0, 0]}
//             />
//           </BarChart>
//         </ResponsiveContainer>
//       </div>
//     </div>
//   );
// };

// export default NewRevenue;

// import React, { useState, useEffect } from 'react';
// import {
//   LineChart,
//   Line,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   Cell
// } from 'recharts';
// import axios from 'axios';

// const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [revenueData, setRevenueData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchRevenueData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) {
//           params.append('year', selectedYear);
//         }

//         if (selectedMonth && selectedMonth !== 'All') {
//           const monthAbbrev = selectedMonth.slice(0, 3);
//           params.append('month', monthAbbrev);
//         }

//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         'Fetching revenue with params:', {
//           year: selectedYear,
//           month: selectedMonth,
//           admin: selectedAdmin,
//           queryString: params.toString()
//         });

//         const response = await axios.get(
//           `http://127.0.0.1:8000/dashboard/api/revenue_summary/?${params.toString()}`
//         );

//         'Revenue API Response:', response.data);
//         setRevenueData(response.data);
//         setError(null);
//       } catch (err) {
//         console.error('Revenue API Error:', err);
//         setError(err.message || 'Failed to fetch revenue data');
//         setRevenueData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRevenueData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   // Transform data based on which response we got
//   // const transformData = () => {
//   //   if (!revenueData) return { chartData: [], chartType: 'bar' };

//   //   if (revenueData.monthly_revenue) {
//   //     // Case: Year provided, show monthly data
//   //     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//   //     return {
//   //       chartData: Object.entries(revenueData.monthly_revenue).map(([month, revenue]) => ({
//   //         name: monthNames[parseInt(month) - 1],
//   //         revenue: revenue
//   //       })),
//   //       chartType: 'bar'
//   //     };
//   //   }

//   //   if (revenueData.yearly_revenue) {
//   //     // Case: No specific year or month provided
//   //     return {
//   //       chartData: Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//   //         name: year,
//   //         revenue: revenue
//   //       })),
//   //       chartType: 'bar'
//   //     };
//   //   }

//   //   return { chartData: [], chartType: 'bar' };
//   // };
//   const transformData = () => {
//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//     if (revenueData?.monthly_revenue) {
//       // Initialize with all months set to 0
//       const chartData = monthNames.map((month, index) => ({
//         name: month,
//         revenue: revenueData.monthly_revenue[index + 1] || 0, // Ensure all months are present
//       }));

//       return { chartData, chartType: 'bar' };
//     }

//     if (revenueData?.yearly_revenue) {
//       return {
//         chartData: Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//           name: year,
//           revenue: revenue,
//         })),
//         chartType: 'bar',
//       };
//     }

//     return { chartData: [], chartType: 'bar' };
//   };

//   const { chartData, chartType } = transformData();

//   return (
//     <div className="p-6 bg-gray-50">
//       {/* Top Cards with improved styling */}
//       <div className="grid grid-cols-2 gap-6 mb-8">
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Total Revenue</div>
//             <div className="p-2 bg-blue-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             ${revenueData?.total_revenue?.toLocaleString() || '0'}
//           </div>
//         </div>

//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Revenue Growth</div>
//             <div className="p-2 bg-green-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             {revenueData?.revenue_growth?.toFixed(2) || '0'}%
//           </div>
//         </div>
//       </div>

//       {/* Revenue Chart with enhanced styling */}
//       <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//         <div className="flex items-center justify-between mb-6">
//           <h3 className="text-lg font-semibold text-gray-800">
//             {selectedYear ? 'Monthly Revenue' : 'Yearly Revenue'}
//           </h3>
//           <div className="flex items-center space-x-2 text-sm text-gray-500">
//             <div className="flex items-center">
//               <div className="w-3 h-3 rounded-full bg-blue-500 mr-2"></div>
//               Revenue
//             </div>
//           </div>
//         </div>

//         <div className="h-[400px]">
//           <ResponsiveContainer width="100%" height="100%">
//           <BarChart data={chartData}>
//   <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
//   <XAxis
//     dataKey="name"
//     axisLine={false}
//     tickLine={false}
//     tick={{ fill: '#6B7280', fontSize: 12 }}
//   />
//   <YAxis
//     axisLine={false}
//     tickLine={false}
//     tick={{ fill: '#6B7280', fontSize: 12 }}
//     width={80}
//     tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`}
//   />
//   <Tooltip
//     formatter={(value) => [`${value.toLocaleString()}`, 'Revenue']}
//     contentStyle={{
//       backgroundColor: 'rgba(255, 255, 255, 0.95)',
//       border: 'none',
//       borderRadius: '8px',
//       boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)'
//     }}
//     labelStyle={{ color: '#374151', fontWeight: 600 }}
//     itemStyle={{ color: '#6B7280' }}
//   />

//   {/* Bar with Dynamic Fill Colors */}
//   <Bar
//     dataKey="revenue"
//     name="Revenue"
//     radius={[4, 4, 0, 0]}
//   >
//     {chartData.map((entry, index) => {
//       let fillColor;
//       if (entry.revenue > 100000) {
//         fillColor = "#22C55E"; // Green for high revenue
//       } else if (entry.revenue > 50000) {
//         fillColor = "#F59E0B"; // Orange for medium revenue
//       } else {
//         fillColor = "#EF4444"; // Red for low revenue
//       }

//       return <Cell key={`cell-${index}`} fill={fillColor} />;
//     })}
//   </Bar>
// </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewRevenue;

// import React, { useState, useEffect } from 'react';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
//   Cell,
//   PieChart,
//   Pie,
//   Legend,
//   LineChart,
//   Line,
//   Defs,
//   LinearGradient,
//   Stop,
// } from 'recharts';
// import axios from 'axios';
// const staticData = {
//   lineChartData: [
//     { name: 'Jan', revenue: 400000, growth: 10 },
//     { name: 'Feb', revenue: 450000, growth: 12.5 },
//     { name: 'Mar', revenue: 500000, growth: 15 },
//     { name: 'Apr', revenue: 550000, growth: 17.5 },
//     { name: 'May', revenue: 600000, growth: 20 },
//     { name: 'Jun', revenue: 650000, growth: 22.5 }
//   ],
//   barChartData: [
//     { name: 'MBA', revenue: 300000 },
//     { name: 'Masters', revenue: 250000 },
//     { name: 'PHD', revenue: 200000 },
//     { name: 'Bachelors', revenue: 100000 }
//   ],
//   pieChartData: [
//     { name: 'USA', value: 400000 },
//     { name: 'UK', value: 300000 },
//     { name: 'Germany', value: 200000 },
//     { name: 'Dubai', value: 100000 }
//   ],
//   serviceData: [
//     {
//       name: 'Jan',
//       service1: 10,
//       service2: 8,
//       service3: 12
//     },
//     {
//       name: 'Feb',
//       service1: 12,
//       service2: 11,
//       service3: 14
//     },
//     {
//       name: 'Mar',
//       service1: 15,
//       service2: 13,
//       service3: 16
//     },
//     {
//       name: 'Apr',
//       service1: 18,
//       service2: 16,
//       service3: 19
//     },
//     {
//       name: 'May',
//       service1: 20,
//       service2: 19,
//       service3: 21
//     },
//     {
//       name: 'Jun',
//       service1: 23,
//       service2: 21,
//       service3: 24
//     }
//   ]
// };

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [revenueData, setRevenueData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchRevenueData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) {
//           params.append('year', selectedYear);
//         }

//         if (selectedMonth && selectedMonth !== 'All') {
//           params.append('month', selectedMonth.slice(0, 3));
//         }

//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         'Fetching revenue with params:', params.toString());

//         const response = await axios.get(
//           `http://127.0.0.1:8000/dashboard/api/revenue_summary/?${params.toString()}`
//         );

//         'Revenue API Response:', response.data);
//         setRevenueData(response.data);
//         setError(null);
//       } catch (err) {
//         console.error('Revenue API Error:', err);
//         setError(err.message || 'Failed to fetch revenue data');
//         setRevenueData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRevenueData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   // Transform data for charts
//   const transformData = () => {
//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//     if (revenueData?.monthly_revenue) {
//       return {
//         chartData: monthNames.map((month, index) => ({
//           name: month,
//           revenue: revenueData.monthly_revenue[index + 1] || 0, // Ensure all months are present
//         })),
//       };
//     }

//     if (revenueData?.yearly_revenue) {
//       return {
//         chartData: Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//           name: year,
//           revenue,
//         })),
//       };
//     }

//     return { chartData: [] };
//   };

//   const { chartData } = transformData();

//   return (
//     <div className="p-6 bg-gray-50">
//       {/* Top Cards with improved styling */}
//       <div className="grid grid-cols-2 gap-6 mb-8">
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Total Revenue</div>
//             <div className="p-2 bg-blue-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             ${revenueData?.total_revenue?.toLocaleString() || '0'}
//           </div>
//         </div>
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Revenue Growth</div>
//             <div className="p-2 bg-green-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             {revenueData?.revenue_growth?.toFixed(2) || '0'}%
//           </div>
//         </div>
//       </div>

//       {/* Revenue Chart */}
//       <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//         <h3 className="text-lg font-semibold text-gray-800 mb-6">
//           {selectedYear ? 'Monthly Revenue' : 'Yearly Revenue'}
//         </h3>

//         <div className="h-[400px]">
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart data={chartData}>
//               <defs>
//                 <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#34D399" /> {/* Light Green */}
//                   <stop offset="100%" stopColor="#059669" /> {/* Dark Green */}
//                 </linearGradient>
//               </defs>

//               <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
//               <XAxis dataKey="name" tick={{ fill: '#6B7280', fontSize: 12 }} />
//               <YAxis tick={{ fill: '#6B7280', fontSize: 12 }} width={80} tickFormatter={(value) => `${(value / 1000).toFixed(0)}k`} />
//               <Tooltip formatter={(value) => [`${value.toLocaleString()}`, 'Revenue']} contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: '8px', boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)' }} />

//               {/* Applying the Gradient to the Bar */}
//               <Bar dataKey="revenue" radius={[4, 4, 0, 0]} fill="url(#revenueGradient)" />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>
//       <div className="bg-white rounded-lg shadow-md p-4">
//             <h3 className="text-lg font-semibold mb-4">Service Revenue</h3>
//             <ResponsiveContainer width="100%" height={300}>
//               <LineChart data={staticData.serviceData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line
//                   type="monotone"
//                   dataKey="service1"
//                   stroke="#82ca9d"
//                   activeDot={{ r: 8 }}
//                   name="Service 1"
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="service2"
//                   stroke="#8884d8"
//                   activeDot={{ r: 8 }}
//                   name="Service 2"
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="service3"
//                   stroke="#ffc658"
//                   activeDot={{ r: 8 }}
//                   name="Service 3"
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//       <div className="space-y-4">
//           {/* Revenue by Segment Pie Chart */}
//           <div className="bg-white rounded-lg shadow-md p-4">
//             <h3 className="text-lg font-semibold mb-4">Revenue by Region</h3>
//             <ResponsiveContainer width="100%" height={300}>
//               <PieChart>
//                 <Pie
//                   data={staticData.pieChartData}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {staticData.pieChartData.map((entry, index) => (
//                     <Cell
//                       key={`cell-${index}`}
//                       fill={COLORS[index % COLORS.length]}
//                     />
//                   ))}
//                 </Pie>
//                 <Tooltip />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>

//           <div className="bg-white rounded-lg shadow-md p-4">
//             <h3 className="text-lg font-semibold mb-4">Level Revenue</h3>
//             <ResponsiveContainer width="100%" height={250}>
//               <BarChart data={staticData.barChartData}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Bar dataKey="revenue" fill="#8884d8" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//     </div>
//   );
// };

// export default NewRevenue;

// import React, { useState, useEffect } from 'react';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//   Cell, PieChart, Pie, Legend, LineChart, Line, Defs, LinearGradient, Stop
// } from 'recharts';

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [revenueData, setRevenueData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchRevenueData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) {
//           params.append('year', selectedYear);
//         }
//         if (selectedMonth && selectedMonth !== 'All') {
//           params.append('month', selectedMonth.slice(0, 3));
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         const response = await fetch(
//           `http://127.0.0.1:8000/dashboard/api/revenue_summary/?${params.toString()}`
//         );
//         const data = await response.json();
//         setRevenueData(data);
//         setError(null);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch revenue data');
//         setRevenueData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRevenueData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   // Transform data for charts
//   const transformMonthlyData = () => {
//     if (!revenueData?.monthly_revenue) return [];
//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
//     return monthNames.map((month, index) => ({
//       name: month,
//       revenue: revenueData.monthly_revenue[index + 1] || 0,
//     }));
//   };

//   const transformYearlyData = () => {
//     if (!revenueData?.yearly_revenue) return [];
//     return Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//       name: year,
//       revenue,
//     }));
//   };

//   const transformRegionData = () => {
//     if (!revenueData?.country_wise_revenue) return [];
//     return Object.entries(revenueData.country_wise_revenue).map(([country, value]) => ({
//       name: country,
//       value,
//     }));
//   };

//   const transformLevelData = () => {
//     if (!revenueData?.category_wise_revenue) return [];
//     return Object.entries(revenueData.category_wise_revenue)
//       .filter(([category]) => category !== 'Unknown')
//       .map(([name, revenue]) => ({
//         name,
//         revenue,
//       }));
//   };

//   const transformServiceData = () => {
//     if (!revenueData?.service_wise_revenue) return [];
//     return Object.entries(revenueData.service_wise_revenue)
//       .slice(0, 5) // Take top 5 services
//       .map(([name, revenue]) => ({
//         name: name.split(' ').slice(0, 2).join(' '), // Truncate service name for better display
//         revenue,
//       }));
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-50">
//       {/* Summary Cards */}
//       <div className="grid grid-cols-2 gap-6 mb-8">
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Total Revenue</div>
//             <div className="p-2 bg-blue-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             ${revenueData?.total_revenue?.toLocaleString() || '0'}
//           </div>
//         </div>
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Revenue Growth</div>
//             <div className="p-2 bg-green-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             {revenueData?.revenue_growth?.toFixed(2) || '0'}%
//           </div>
//         </div>
//       </div>

//       {/* Main Revenue Chart */}
//       <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-100">
//         <h3 className="text-lg font-semibold text-gray-800 mb-6">
//           {selectedYear ? 'Monthly Revenue' : 'Yearly Revenue'}
//         </h3>
//         <div className="h-96">
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart data={selectedYear ? transformMonthlyData() : transformYearlyData()}>
//               <defs>
//                 <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#34D399" />
//                   <stop offset="100%" stopColor="#059669" />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
//               <XAxis dataKey="name" tick={{ fill: '#6B7280', fontSize: 12 }} />
//               <YAxis tick={{ fill: '#6B7280', fontSize: 12 }} width={80}
//                 tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`} />
//               <Tooltip
//                 formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']}
//                 contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: '8px' }} />
//               <Bar dataKey="revenue" radius={[4, 4, 0, 0]} fill="url(#revenueGradient)" />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       <div className="grid grid-cols-2 gap-6">
//         {/* Region Revenue Pie Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Revenue by Region</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={transformRegionData()}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {transformRegionData().map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
//                 <Legend />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Level Revenue Bar Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Level Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={transformLevelData()}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis tickFormatter={(value) => `$${(value / 1000)}k`} />
//                 <Tooltip formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']} />
//                 <Bar dataKey="revenue" fill="#8884d8" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Service Revenue Line Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 col-span-2">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Top Services Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={transformServiceData()}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis tickFormatter={(value) => `$${(value / 1000)}k`} />
//                 <Tooltip formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']} />
//                 <Bar dataKey="revenue" fill="#82ca9d" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewRevenue;

// import React, { useState, useEffect } from 'react';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//   Cell, PieChart, Pie, Legend, LineChart, Line, Defs, LinearGradient, Stop
// } from 'recharts';

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [revenueData, setRevenueData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchRevenueData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) {
//           params.append('year', selectedYear);
//         }
//         if (selectedMonth && selectedMonth !== 'All') {
//           params.append('month', selectedMonth.slice(0, 3));
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         const response = await fetch(
//           `http://127.0.0.1:8000/dashboard/api/revenue_summary/?${params.toString()}`
//         );
//         const data = await response.json();
//         setRevenueData(data);
//         setError(null);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch revenue data');
//         setRevenueData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRevenueData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   // Transform data for charts
//   const transformMonthlyData = () => {
//     // If no monthly_revenue data, create a data point using total_revenue
//     if (!revenueData?.monthly_revenue && selectedMonth && selectedMonth !== 'All') {
//       return [{
//         name: selectedMonth.slice(0, 3),
//         revenue: revenueData?.total_revenue || 0
//       }];
//     }

//     // If no monthly_revenue and no specific month selected, return empty array
//     if (!revenueData?.monthly_revenue) return [];

//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//     // If no specific month selected, show all months
//     return monthNames.map((month, index) => ({
//       name: month,
//       revenue: revenueData.monthly_revenue[index + 1] || 0
//     }));
//   };

//   const transformYearlyData = () => {
//     if (!revenueData?.yearly_revenue) return [];
//     return Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//       name: year,
//       revenue,
//     }));
//   };

//   const transformRegionData = () => {
//     if (!revenueData?.country_wise_revenue) return [];
//     return Object.entries(revenueData.country_wise_revenue).map(([country, value]) => ({
//       name: country,
//       value,
//     }));
//   };

//   const transformLevelData = () => {
//     if (!revenueData?.category_wise_revenue) return [];
//     return Object.entries(revenueData.category_wise_revenue)
//       .filter(([category]) => category !== 'Unknown')
//       .map(([name, revenue]) => ({
//         name,
//         revenue,
//       }));
//   };

//   const transformServiceData = () => {
//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];

//     // Get top 3 services by revenue
//     const topServices = Object.entries(revenueData?.service_wise_revenue || {})
//       .sort(([, a], [, b]) => b - a)
//       .slice(0, 3)
//       .map(([name]) => name);

//     // Create monthly data points with increasing trend
//     return monthNames.map((month, index) => {
//       const baseValue = 10; // Starting value
//       const growth = 2; // Growth rate

//       return {
//         name: month,
//         service1: baseValue + (index * growth),
//         service2: (baseValue - 2) + (index * growth),
//         service3: (baseValue + 2) + (index * growth),
//       };
//     });
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         Loading....
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-50">
//       {/* Summary Cards */}
//       <div className="grid grid-cols-2 gap-6 mb-8">
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Total Revenue</div>
//             <div className="p-2 bg-blue-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             ${revenueData?.total_revenue?.toLocaleString() || '0'}
//           </div>
//         </div>
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Revenue Growth</div>
//             <div className="p-2 bg-green-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             {revenueData?.revenue_growth?.toFixed(2) || '0'}%
//           </div>
//         </div>
//       </div>

//       {/* Main Revenue Chart */}
//       <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-100">
//         <h3 className="text-lg font-semibold text-gray-800 mb-6">
//           {selectedYear ? 'Monthly Revenue' : 'Yearly Revenue'}
//         </h3>
//         <div className="h-96">
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart data={selectedYear ? transformMonthlyData() : transformYearlyData()}>
//               <defs>
//                 <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#34D399" />
//                   <stop offset="100%" stopColor="#059669" />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
//               <XAxis dataKey="name" tick={{ fill: '#6B7280', fontSize: 12 }} />
//               <YAxis tick={{ fill: '#6B7280', fontSize: 12 }} width={80}
//                 tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`} />
//               <Tooltip
//                 formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']}
//                 contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: '8px' }} />
//               <Bar dataKey="revenue" radius={[4, 4, 0, 0]} fill="url(#revenueGradient)" />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       <div className="grid grid-cols-2 gap-6">
//         {/* Region Revenue Pie Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Revenue by Region</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={transformRegionData()}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {transformRegionData().map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
//                 <Legend />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Level Revenue Bar Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Level Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={transformLevelData()}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis tickFormatter={(value) => `$${(value / 1000)}k`} />
//                 <Tooltip formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']} />
//                 <Bar dataKey="revenue" fill="#8884d8" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Service Revenue Line Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 col-span-2">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Top Services Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={transformServiceData()}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line
//                   type="monotone"
//                   dataKey="service1"
//                   stroke="#82ca9d"
//                   activeDot={{ r: 8 }}
//                   name="Service 1"
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="service2"
//                   stroke="#8884d8"
//                   activeDot={{ r: 8 }}
//                   name="Service 2"
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="service3"
//                   stroke="#ffc658"
//                   activeDot={{ r: 8 }}
//                   name="Service 3"
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewRevenue;

// import React, { useState, useEffect } from 'react';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//   Cell, PieChart, Pie, Legend, LineChart, Line, Defs, LinearGradient, Stop
// } from 'recharts';

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [revenueData, setRevenueData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const fetchRevenueData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) {
//           params.append('year', selectedYear);
//         }
//         if (selectedMonth && selectedMonth !== 'All') {
//           params.append('month', selectedMonth.slice(0, 3));
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         const response = await fetch(
//           `http://127.0.0.1:8000/dashboard/api/revenue_summary/?${params.toString()}`
//         );
//         const data = await response.json();
//         setRevenueData(data);
//         setError(null);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch revenue data');
//         setRevenueData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRevenueData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   // Transform data for charts
//   const transformMonthlyData = () => {
//     // If no monthly_revenue data, create a data point using total_revenue
//     if (!revenueData?.monthly_revenue && selectedMonth && selectedMonth !== 'All') {
//       return [{
//         name: selectedMonth.slice(0, 3),
//         revenue: revenueData?.total_revenue || 0
//       }];
//     }

//     // If no monthly_revenue and no specific month selected, return empty array
//     if (!revenueData?.monthly_revenue) return [];

//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//     // If no specific month selected, show all months
//     return monthNames.map((month, index) => ({
//       name: month,
//       revenue: revenueData.monthly_revenue[index + 1] || 0
//     }));
//   };

//   const transformYearlyData = () => {
//     if (!revenueData?.yearly_revenue) return [];
//     return Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//       name: year,
//       revenue,
//     }));
//   };

//   const transformRegionData = () => {
//     if (!revenueData?.country_wise_revenue) return [];
//     return Object.entries(revenueData.country_wise_revenue).map(([country, value]) => ({
//       name: country,
//       value,
//     }));
//   };

//   const transformLevelData = () => {
//     if (!revenueData?.category_wise_revenue) return [];
//     return Object.entries(revenueData.category_wise_revenue)
//       .filter(([category]) => category !== 'Unknown')
//       .map(([name, revenue]) => ({
//         name,
//         revenue,
//       }));
//   };

//   const transformServiceData = () => {
//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];

//     // Get top 3 services by revenue
//     const topServices = Object.entries(revenueData?.service_wise_revenue || {})
//       .sort(([, a], [, b]) => b - a)
//       .slice(0, 3)
//       .map(([name]) => name);

//     // Create monthly data points with increasing trend
//     return monthNames.map((month, index) => {
//       const baseValue = 10; // Starting value
//       const growth = 2; // Growth rate

//       return {
//         name: month,
//         service1: baseValue + (index * growth),
//         service2: (baseValue - 2) + (index * growth),
//         service3: (baseValue + 2) + (index * growth),
//       };
//     });
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         Loading....
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-50">
//       {/* Summary Cards */}
//       <div className="grid grid-cols-2 gap-6 mb-8">
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Total Revenue</div>
//             <div className="p-2 bg-blue-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             ${revenueData?.total_revenue?.toLocaleString() || '0'}
//           </div>
//         </div>
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Revenue Growth</div>
//             <div className="p-2 bg-green-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             {revenueData?.revenue_growth?.toFixed(2) || '0'}%
//           </div>
//         </div>
//       </div>

//       {/* Main Revenue Chart */}
//       <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-100">
//         <h3 className="text-lg font-semibold text-gray-800 mb-6">
//           {selectedYear ? 'Monthly Revenue' : 'Yearly Revenue'}
//         </h3>
//         <div className="h-96">
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart data={selectedYear ? transformMonthlyData() : transformYearlyData()}>
//               <defs>
//                 <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#34D399" />
//                   <stop offset="100%" stopColor="#059669" />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
//               <XAxis dataKey="name" tick={{ fill: '#6B7280', fontSize: 12 }} />
//               <YAxis tick={{ fill: '#6B7280', fontSize: 12 }} width={80}
//                 tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`} />
//               <Tooltip
//                 formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']}
//                 contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: '8px' }} />
//               <Bar dataKey="revenue" radius={[4, 4, 0, 0]} fill="url(#revenueGradient)" />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       <div className="grid grid-cols-2 gap-6">
//         {/* Region Revenue Pie Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Revenue by Region</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={transformRegionData()}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {transformRegionData().map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
//                 <Legend />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Level Revenue Bar Chart */}
//         {/* <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Level Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={transformLevelData()}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis tickFormatter={(value) => `$${(value / 1000)}k`} />
//                 <Tooltip formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']} />
//                 <Bar dataKey="revenue" fill="#8884d8" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div> */}
//   <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Level Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={transformLevelData()}>
//                 <defs>
//                   <linearGradient id="levelRevenueGradient" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%" stopColor="#A78BFA" />
//                     <stop offset="100%" stopColor="#7C3AED" />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis tickFormatter={(value) => `$${(value / 1000)}k`} />
//                 <Tooltip formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']} />
//                 <Bar dataKey="revenue" fill="url(#levelRevenueGradient)" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//         {/* Service Revenue Line Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 col-span-2">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Top Services Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={transformServiceData()}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis />
//                 <Tooltip />
//                 <Legend />
//                 <Line
//                   type="monotone"
//                   dataKey="service1"
//                   stroke="#82ca9d"
//                   activeDot={{ r: 8 }}
//                   name="Service 1"
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="service2"
//                   stroke="#8884d8"
//                   activeDot={{ r: 8 }}
//                   name="Service 2"
//                 />
//                 <Line
//                   type="monotone"
//                   dataKey="service3"
//                   stroke="#ffc658"
//                   activeDot={{ r: 8 }}
//                   name="Service 3"
//                 />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewRevenue;

// import React, { useState, useEffect } from 'react';
// import {
//   BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer,
//   Cell, PieChart, Pie, Legend, LineChart, Line, Defs, LinearGradient, Stop
// } from 'recharts';
// import { Check } from 'lucide-react';

// const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042'];

// // Multi-select dropdown component
// const MultiSelectDropdown = ({ options, selected, onChange }) => {
//   const [isOpen, setIsOpen] = useState(false);

//   return (
//     <div className="relative">
//       <button
//         onClick={() => setIsOpen(!isOpen)}
//         className="w-64 flex items-center justify-between px-4 py-2 text-sm bg-white border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
//       >
//         <span className="text-gray-700">
//           {selected.length === 0
//             ? 'Select Services'
//             : `${selected.length} service${selected.length !== 1 ? 's' : ''} selected`}
//         </span>
//         <svg
//           className={`w-4 h-4 transition-transform ${isOpen ? 'rotate-180' : ''}`}
//           fill="none"
//           stroke="currentColor"
//           viewBox="0 0 24 24"
//         >
//           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
//         </svg>
//       </button>

//       {isOpen && (
//         <div className="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg">
//           <div className="p-2 space-y-1 max-h-60 overflow-auto">
//             {options.map((option) => (
//               <label
//                 key={option.id}
//                 className="flex items-center px-3 py-2 rounded hover:bg-gray-100 cursor-pointer"
//               >
//                 <input
//                   type="checkbox"
//                   className="hidden"
//                   checked={selected.includes(option.core_service_name)}
//                   onChange={() => {
//                     const newSelected = selected.includes(option.core_service_name)
//                       ? selected.filter(item => item !== option.core_service_name)
//                       : [...selected, option.core_service_name];
//                     onChange(newSelected);
//                   }}
//                 />
//                 <div className="w-4 h-4 border rounded mr-2 flex items-center justify-center">
//                   {selected.includes(option.core_service_name) && (
//                     <Check className="w-3 h-3 text-blue-600" />
//                   )}
//                 </div>
//                 <span className="text-sm text-gray-700">{option.core_service_name}</span>
//               </label>
//             ))}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
//   const [selectedServices, setSelectedServices] = useState([]);
//   const [servicesData, setServicesData] = useState([]);
//   const [revenueData, setRevenueData] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch services data
//   useEffect(() => {
//     const fetchServices = async () => {
//       try {
//         const response = await fetch('http://127.0.0.1:8000/invoice_price/api/core-services/');
//         const data = await response.json();
//         setServicesData(data);
//         setSelectedServices(data.map(service => service.core_service_name));
//       } catch (error) {
//         console.error('Error fetching services:', error);
//       }
//     };

//     fetchServices();
//   }, []);

//   // Fetch revenue data
//   useEffect(() => {
//     const fetchRevenueData = async () => {
//       try {
//         setLoading(true);
//         const params = new URLSearchParams();

//         if (selectedYear) {
//           params.append('year', selectedYear);
//         }
//         if (selectedMonth && selectedMonth !== 'All') {
//           params.append('month', selectedMonth.slice(0, 3));
//         }
//         if (selectedAdmin && selectedAdmin !== 'all') {
//           params.append('created_by', selectedAdmin);
//         }

//         const response = await fetch(
//           `http://127.0.0.1:8000/dashboard/api/revenue_summary/?${params.toString()}`
//         );
//         const data = await response.json();
//         setRevenueData(data);
//         setError(null);
//       } catch (err) {
//         setError(err.message || 'Failed to fetch revenue data');
//         setRevenueData(null);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchRevenueData();
//   }, [selectedYear, selectedMonth, selectedAdmin]);

//   // Transform data for charts
//   const transformMonthlyData = () => {
//     if (!revenueData?.monthly_revenue && selectedMonth && selectedMonth !== 'All') {
//       return [{
//         name: selectedMonth.slice(0, 3),
//         revenue: revenueData?.total_revenue || 0
//       }];
//     }

//     if (!revenueData?.monthly_revenue) return [];

//     const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

//     return monthNames.map((month, index) => ({
//       name: month,
//       revenue: revenueData.monthly_revenue[index + 1] || 0
//     }));
//   };

//   const transformYearlyData = () => {
//     if (!revenueData?.yearly_revenue) return [];
//     return Object.entries(revenueData.yearly_revenue).map(([year, revenue]) => ({
//       name: year,
//       revenue,
//     }));
//   };

//   const transformRegionData = () => {
//     if (!revenueData?.country_wise_revenue) return [];
//     return Object.entries(revenueData.country_wise_revenue).map(([country, value]) => ({
//       name: country,
//       value,
//     }));
//   };

//   const transformLevelData = () => {
//     if (!revenueData?.category_wise_revenue) return [];
//     return Object.entries(revenueData.category_wise_revenue)
//       .filter(([category]) => category !== 'Unknown')
//       .map(([name, revenue]) => ({
//         name,
//         revenue,
//       }));
//   };
//   const transformServiceData = () => {
//     if (!revenueData?.service_wise_monthly_revenue) return [];

//     // Get all months from the data
//     const months = Object.keys(revenueData.service_wise_monthly_revenue);

//     return months.map(month => {
//       const monthData = {
//         name: month,
//       };

//       // Add revenue for each selected service
//       selectedServices.forEach(serviceName => {
//         monthData[serviceName] = revenueData.service_wise_monthly_revenue[month]?.[serviceName] || 0;
//       });

//       return monthData;
//     });
//   };

//   if (loading) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         Loading....
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="flex items-center justify-center h-64">
//         <div className="text-red-500">Error: {error}</div>
//       </div>
//     );
//   }

//   return (
//     <div className="p-6 bg-gray-50">
//       {/* Summary Cards */}
//       <div className="grid grid-cols-2 gap-6 mb-8">
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Total Revenue</div>
//             <div className="p-2 bg-blue-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             ${revenueData?.total_revenue?.toLocaleString() || '0'}
//           </div>
//         </div>
//         <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
//           <div className="flex items-center justify-between mb-3">
//             <div className="text-sm font-medium text-gray-500">Revenue Growth</div>
//             <div className="p-2 bg-green-50 rounded-lg">
//               <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//                 <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
//               </svg>
//             </div>
//           </div>
//           <div className="text-3xl font-bold text-gray-800">
//             {revenueData?.revenue_growth?.toFixed(2) || '0'}%
//           </div>
//         </div>
//       </div>

//       {/* Main Revenue Chart */}
//       <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-100">
//         <h3 className="text-lg font-semibold text-gray-800 mb-6">
//           {selectedYear ? 'Monthly Revenue' : 'Yearly Revenue'}
//         </h3>
//         <div className="h-96">
//           <ResponsiveContainer width="100%" height="100%">
//             <BarChart data={selectedYear ? transformMonthlyData() : transformYearlyData()}>
//               <defs>
//                 <linearGradient id="revenueGradient" x1="0" y1="0" x2="0" y2="1">
//                   <stop offset="0%" stopColor="#34D399" />
//                   <stop offset="100%" stopColor="#059669" />
//                 </linearGradient>
//               </defs>
//               <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" vertical={false} />
//               <XAxis dataKey="name" tick={{ fill: '#6B7280', fontSize: 12 }} />
//               <YAxis
//                 tick={{ fill: '#6B7280', fontSize: 12 }}
//                 width={80}
//                 tickFormatter={(value) => `$${(value / 1000).toFixed(0)}k`}
//               />
//               <Tooltip
//                 formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']}
//                 contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: '8px' }}
//               />
//               <Bar dataKey="revenue" radius={[4, 4, 0, 0]} fill="url(#revenueGradient)" />
//             </BarChart>
//           </ResponsiveContainer>
//         </div>
//       </div>

//       <div className="grid grid-cols-2 gap-6">
//         {/* Region Revenue Pie Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Revenue by Region</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Pie
//                   data={transformRegionData()}
//                   cx="50%"
//                   cy="50%"
//                   labelLine={false}
//                   outerRadius={80}
//                   fill="#8884d8"
//                   dataKey="value"
//                 >
//                   {transformRegionData().map((entry, index) => (
//                     <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                   ))}
//                 </Pie>
//                 <Tooltip formatter={(value) => `$${value.toLocaleString()}`} />
//                 <Legend />
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Level Revenue Bar Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
//           <h3 className="text-lg font-semibold text-gray-800 mb-6">Level Revenue</h3>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <BarChart data={transformLevelData()}>
//                 <defs>
//                   <linearGradient id="levelRevenueGradient" x1="0" y1="0" x2="0" y2="1">
//                     <stop offset="0%" stopColor="#A78BFA" />
//                     <stop offset="100%" stopColor="#7C3AED" />
//                   </linearGradient>
//                 </defs>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="name" />
//                 <YAxis tickFormatter={(value) => `$${(value / 1000)}k`} />
//                 <Tooltip formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']} />
//                 <Bar dataKey="revenue" fill="url(#levelRevenueGradient)" />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>

//         {/* Service Revenue Line Chart */}
//         <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 col-span-2">
//           <div className="flex justify-between items-center mb-6">
//             <h3 className="text-lg font-semibold text-gray-800">Services Revenue Comparison</h3>
//             <MultiSelectDropdown
//               options={servicesData}
//               selected={selectedServices}
//               onChange={setSelectedServices}
//             />
//           </div>
//           <div className="h-80">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={transformServiceData()}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis
//                   dataKey="name"
//                   label={{
//                     value: 'Months',
//                     position: 'bottom',
//                     offset: 0
//                   }}
//                 />
//                 <YAxis
//                   label={{
//                     value: 'Revenue Amount ($)',
//                     angle: -90,
//                     position: 'insideLeft',
//                     offset: -10
//                   }}
//                   tickFormatter={(value) => `$${(value / 1000)}k`}
//                 />
//                 <Tooltip
//                   formatter={(value) => [`$${value.toLocaleString()}`, 'Revenue']}
//                   contentStyle={{ backgroundColor: 'rgba(255, 255, 255, 0.95)', borderRadius: '8px' }}
//                 />
//                 <Legend />
//                 {selectedServices.map((service, index) => (
//                   <Line
//                     key={service}
//                     type="monotone"
//                     dataKey={service}
//                     stroke={COLORS[index % COLORS.length]}
//                     activeDot={{ r: 8 }}
//                     name={service}
//                     strokeWidth={2}
//                   />
//                 ))}
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default NewRevenue;

import React, { useState, useEffect } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Cell,
  PieChart,
  Pie,
  Legend,
  LineChart,
  Line,
  Defs,
  LinearGradient,
  Stop,
} from "recharts";
import { Check } from "lucide-react";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042"];

// Multi-select dropdown component
const MultiSelectDropdown = ({ options, selected, onChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-64 flex items-center justify-between px-4 py-2 text-sm bg-white border rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        <span className="text-gray-700">
          {selected.length === 0
            ? "Select Services"
            : `${selected.length} service${
                selected.length !== 1 ? "s" : ""
              } selected`}
        </span>
        <svg
          className={`w-4 h-4 transition-transform ${
            isOpen ? "rotate-180" : ""
          }`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M19 9l-7 7-7-7"
          />
        </svg>
      </button>

      {isOpen && (
        <div className="absolute z-10 w-full mt-1 bg-white border rounded-lg shadow-lg">
          <div className="p-2 space-y-1 max-h-60 overflow-auto">
            {options.map((option) => (
              <label
                key={option.id}
                className="flex items-center px-3 py-2 rounded hover:bg-gray-100 cursor-pointer"
              >
                <input
                  type="checkbox"
                  className="hidden"
                  checked={selected.includes(option.core_service_name)}
                  onChange={() => {
                    const newSelected = selected.includes(
                      option.core_service_name
                    )
                      ? selected.filter(
                          (item) => item !== option.core_service_name
                        )
                      : [...selected, option.core_service_name];
                    onChange(newSelected);
                  }}
                />
                <div className="w-4 h-4 border rounded mr-2 flex items-center justify-center">
                  {selected.includes(option.core_service_name) && (
                    <Check className="w-3 h-3 text-blue-600" />
                  )}
                </div>
                <span className="text-sm text-gray-700">
                  {option.core_service_name}
                </span>
              </label>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

const NewRevenue = ({ selectedYear, selectedMonth, selectedAdmin }) => {
  const [selectedServices, setSelectedServices] = useState([]);
  const [servicesData, setServicesData] = useState([]);
  const [revenueData, setRevenueData] = useState(null);
  const [serviceRevenueData, setServiceRevenueData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch services data
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/invoice_price/api/core-services/`
        );
        const data = await response.json();
        setServicesData(data);
        setSelectedServices(data.map((service) => service.core_service_name));
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };

    fetchServices();
  }, []);

  // Fetch revenue data
  useEffect(() => {
    const fetchRevenueData = async () => {
      try {
        setLoading(true);
        const params = new URLSearchParams();

        if (selectedYear) {
          params.append("year", selectedYear);
        }
        if (selectedAdmin && selectedAdmin !== "all") {
          params.append("created_by", selectedAdmin);
        }

        const response = await fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/dashboard/api/revenue_summary/?${params.toString()}`
        );
        const data = await response.json();
        setRevenueData(data);
        setError(null);
      } catch (err) {
        setError(err.message || "Failed to fetch revenue data");
        setRevenueData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchRevenueData();
  }, [selectedYear, selectedMonth, selectedAdmin]);

  // Fetch service revenue data
  useEffect(() => {
    const fetchServiceRevenue = async () => {
      try {
        const params = new URLSearchParams();

        if (selectedYear) {
          params.append("year", selectedYear);
        }

        const response = await fetch(
          `${
            process.env.REACT_APP_BASE_URL
          }/dashboard/api/revenue_by_service/?${params.toString()}`
        );
        const data = await response.json();
        setServiceRevenueData(data);
      } catch (err) {
        console.error("Failed to fetch service revenue data:", err);
      }
    };

    fetchServiceRevenue();
  }, [selectedYear]);

  // Transform data for charts
  const transformMonthlyData = () => {
    if (!revenueData?.monthly_revenue) return [];

    // If a specific month is selected, display revenue for that month only
    if (selectedMonth && selectedMonth !== "All") {
      const monthIndex = new Date(`${selectedMonth} 1, 2025`).getMonth() + 1; // Convert month name to month number (1-12)
      const revenue = revenueData?.monthly_revenue[monthIndex] || 0;

      return [
        {
          name: selectedMonth.slice(0, 3), // Abbreviated month name
          revenue: revenue,
        },
      ];
    }

    // If no specific month is selected or "All" is selected, display all months
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    // Loop through all months and get the revenue for each month from the `monthly_revenue` object
    return monthNames.map((month, index) => {
      const monthIndex = index + 1; // Months are 1-indexed (1 = Jan, 12 = Dec)
      const revenue = revenueData?.monthly_revenue[monthIndex] || 0;

      return {
        name: month,
        revenue: revenue,
      };
    });
  };

  const transformYearlyData = () => {
    if (!revenueData?.yearly_revenue) return [];
    return Object.entries(revenueData.yearly_revenue).map(
      ([year, revenue]) => ({
        name: year,
        revenue,
      })
    );
  };

  const transformRegionData = () => {
    if (!revenueData?.country_wise_revenue) return [];
    return Object.entries(revenueData.country_wise_revenue).map(
      ([country, value]) => ({
        name: country,
        value,
      })
    );
  };

  const transformLevelData = () => {
    if (!revenueData?.category_wise_revenue) return [];
    return Object.entries(revenueData.category_wise_revenue)
      .filter(([category]) => category !== "Unknown")
      .map(([name, revenue]) => ({
        name,
        revenue,
      }));
  };

  const transformServiceData = () => {
    if (!serviceRevenueData?.service_wise_revenue) return [];

    // Get all unique months from the data
    const allMonths = new Set();
    Object.values(serviceRevenueData.service_wise_revenue).forEach(
      (monthData) => {
        Object.keys(monthData).forEach((month) => allMonths.add(month));
      }
    );

    // Sort months chronologically
    const monthOrder = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const sortedMonths = Array.from(allMonths).sort(
      (a, b) => monthOrder.indexOf(a) - monthOrder.indexOf(b)
    );

    // Create data points for each month
    return sortedMonths.map((month) => {
      const dataPoint = {
        name: month.slice(0, 3), // Abbreviated month name
      };

      // Add revenue for each selected service
      selectedServices.forEach((service) => {
        const serviceData = serviceRevenueData.service_wise_revenue[service];
        dataPoint[service] = serviceData?.[month] || 0;
      });

      return dataPoint;
    });
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">Loading....</div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-red-500">Error: {error}</div>
      </div>
    );
  }

  return (
    <div className="p-6 bg-gray-50">
      {/* Summary Cards */}
      <div className="grid grid-cols-2 gap-6 mb-8">
        <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
          <div className="flex items-center justify-between mb-3">
            <div className="text-sm font-medium text-gray-500">
              Total Revenue
            </div>
            <div className="p-2 bg-blue-50 rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-blue-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
          </div>
          <div className="text-3xl font-bold text-gray-800">
            ₹{revenueData?.total_revenue?.toLocaleString() || "0"}
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-lg p-6 transition-all duration-300 hover:shadow-xl border border-gray-100">
          <div className="flex items-center justify-between mb-3">
            <div className="text-sm font-medium text-gray-500">
              Revenue Growth
            </div>
            <div className="p-2 bg-green-50 rounded-lg">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
                />
              </svg>
            </div>
          </div>
          <div className="text-3xl font-bold text-gray-800">
            {revenueData?.revenue_growth?.toFixed(2) || "0"}%
          </div>
        </div>
      </div>

      {/* Main Revenue Chart */}
      <div className="bg-white rounded-xl shadow-lg p-6 mb-6 border border-gray-100">
        <h3 className="text-lg font-semibold text-gray-800 mb-6">
          {selectedYear ? "Monthly Revenue" : "Yearly Revenue"}
        </h3>
        <div className="h-96">
          <ResponsiveContainer width="100%" height="100%">
            <BarChart
              data={
                selectedYear ? transformMonthlyData() : transformYearlyData()
              }
            >
              <defs>
                <linearGradient
                  id="revenueGradient"
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="0%" stopColor="#34D399" />
                  <stop offset="100%" stopColor="#059669" />
                </linearGradient>
              </defs>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="#E5E7EB"
                vertical={false}
              />
              <XAxis dataKey="name" tick={{ fill: "#6B7280", fontSize: 12 }} />
              <YAxis
                tick={{ fill: "#6B7280", fontSize: 12 }}
                width={80}
                tickFormatter={(value) => `₹${(value / 1000).toFixed(0)}k`}
              />
              <Tooltip
                formatter={(value) => [`₹${value.toLocaleString()}`, "Revenue"]}
                contentStyle={{
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  borderRadius: "8px",
                }}
              />
              <Bar
                dataKey="revenue"
                radius={[4, 4, 0, 0]}
                fill="url(#revenueGradient)"
              />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-6">
        {/* Region Revenue Pie Chart */}
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-800 mb-6">
            Revenue by Region
          </h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <PieChart>
                <Pie
                  data={transformRegionData()}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                >
                  {transformRegionData().map((entry, index) => (
                    <Cell
                      key={`cell-${index}`}
                      fill={COLORS[index % COLORS.length]}
                    />
                  ))}
                </Pie>
                <Tooltip formatter={(value) => `₹${value.toLocaleString()}`} />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Level Revenue Bar Chart */}
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100">
          <h3 className="text-lg font-semibold text-gray-800 mb-6">
            Level Revenue
          </h3>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={transformLevelData()}>
                <defs>
                  <linearGradient
                    id="levelRevenueGradient"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop offset="0%" stopColor="#A78BFA" />
                    <stop offset="100%" stopColor="#7C3AED" />
                  </linearGradient>
                </defs>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis tickFormatter={(value) => `₹${value / 1000}k`} />
                <Tooltip
                  formatter={(value) => [
                    `₹${value.toLocaleString()}`,
                    "Revenue",
                  ]}
                />
                <Bar dataKey="revenue" fill="url(#levelRevenueGradient)" />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Service Revenue Line Chart */}
        <div className="bg-white rounded-xl shadow-lg p-6 border border-gray-100 col-span-2">
          <div className="flex justify-between items-center mb-6">
            <h3 className="text-lg font-semibold text-gray-800">
              Services Revenue Comparison
            </h3>
            <MultiSelectDropdown
              options={servicesData}
              selected={selectedServices}
              onChange={setSelectedServices}
            />
          </div>
          <div className="h-80">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart
                data={transformServiceData()}
                margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis
                  dataKey="name"
                  label={{
                    value: "Months",
                    position: "insideBottom",
                    offset: -10,
                  }}
                />
                <YAxis
                  label={{
                    value: "Revenue Amount (₹)",
                    angle: -90,
                    position: "insideLeft",
                    offset: -5,
                  }}
                  tickFormatter={(value) => `₹${value / 1000}k`}
                />
                <Tooltip
                  formatter={(value) => [
                    `₹${value.toLocaleString()}`,
                    "Revenue",
                  ]}
                  contentStyle={{
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb",
                  }}
                />
                <Legend verticalAlign="top" height={36} />
                {selectedServices.map((service, index) => (
                  <Line
                    key={service}
                    type="monotone"
                    dataKey={service}
                    stroke={COLORS[index % COLORS.length]}
                    activeDot={{ r: 6 }}
                    name={service}
                    strokeWidth={2}
                    dot={{ strokeWidth: 2 }}
                  />
                ))}
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewRevenue;
